import { useState } from 'react';
import eu from '../../../../../../images/eu.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { CircularProgress } from '@mui/material';
import { BASTIDORES_API } from '../../../shared/services/bastidores';
import { matriculaPaises } from '../../matriculaPaises';
import { toast } from 'react-toastify';

const MatriculaSearch = ({ setBastidores, getBastidores }) => {
    const [matricula, setMatricula] = useState('');
    const [pais, setPais] = useState('ES')
    const [isLoading, setIsLoading] = useState(false);

    const submitSearch = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const res = await BASTIDORES_API.getByMatricula({ matricula, pais });
            if (res.success) {
                return setBastidores({total_pages: 1, results:[res.data]});
            }
            toast.error('No se ha encontrado el bastidor.');
        } catch (e) {
            toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        setMatricula('');
        getBastidores();
    }

    return (
        <div className="matricula-search">
            <select onChange={(e) => setPais(e.target.value)} value={pais}>
                {matriculaPaises.map(({ name, country_code }) => (
                    <option key={country_code} value={country_code}>{name}</option>
                ))}
            </select>
            <div className="matricula-search__search">
                <span className="plate-eu">
                    <img src={eu} alt="eu" />E
                </span>
                <input
                    type="text"
                    placeholder="0000FFF"
                    className="matricula-search__search--input"
                    value={matricula}
                    onChange={(e) => {
                        setMatricula(e.target.value.toUpperCase().replace(/[\s-]+/g, ''));
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            submitSearch();
                        }
                    }}
                />
                <span className="matricula-search__search--icon">
                    {isLoading ? (
                        <CircularProgress size="15px" color="inherit" />
                    ) : (
                        <FontAwesomeIcon
                            icon={faMagnifyingGlass}
                            onClick={() => submitSearch()}
                        />
                    )}
                </span>
            </div>
            <FontAwesomeIcon className='refresh-icon' icon={faRotateRight} onClick={handleRefresh} />
        </div>
    );
};

export default MatriculaSearch;
